import TYPES from './types';

const init = () => {
  return {
    list: []
  };
};



const reducer = (state, action) => {
  switch (action.type) {
    case TYPES.FUELSURCHARGE_GET_PRICE: {
      if(action.pending) {
        return {
          ...state,
        }
      }
      if(action.error) {
        return {
          ...state,
        }
      }
      return {
        ...state,
        list: action.payload.data.list,
        updateAt: action.payload.data.updatedAt,
      }
    }
    default: {
      return {
        ...state
      }
    }
  };
}

export default {reducer, init};


// WEBPACK FOOTER //
// ./src/pages/FuelSurchargePage/state/reducer.js